import { useContext } from "react";
import { AppContext } from "../State/Context";
import { BasicPopup } from "./BasicPopup";
import { ActionType } from "../State/State";

export const AboutGamePopup: React.FC = () => {
  const { dispatch } = useContext(AppContext);
  const closePopup = () => {
    dispatch({ type: ActionType.TOGGLE_ABOUT_GAME_POPUP });
  };
  return (
    <BasicPopup onClose={closePopup}>
      <div className="">
        <h1 className="text-2xl font-bold pb-4">About Game and Rules</h1>
        <p>
          <b>Hexagen.World</b> is a collectively generated game world created by
          all players.
        </p>
        <p className="py-6 font-bold text-lg">The rules are simple: </p>
        <ul className="list-disc pl-4 [&>li]:mb-3">
          <li>
            1️⃣ Explore the edge of the world using the map or simply drag the
            canvas to navigate.
          </li>
          <li>2️⃣ Click on an empty hexagon at the edge to begin.</li>
          <li>
            3️⃣ Come up with a prompt and generate a piece of the world in the
            selected hexagon.
          </li>
          <li>
            4️⃣ AI gives your hexagon a creativity score. This score does not
            add points to your balance.
          </li>
        </ul>
        <div className="font-bold py-6 text-lg">
          Generation Costs
        </div>
        <ul className="list-disc pl-4 mb-6 [&>li]:mb-2">
          <li>
            <div className="font-bold">New hexagon generation:</div>
            <div className="ml-4">
              1 neighbor: 350 points | 2 neighbors: 200 points | 3 neighbors: 100 points | 4 neighbors: 50 points | 5+ neighbors: free
            </div>
            <div className="ml-4 mt-2">You can use 2 Sparks instead of points.</div>
          </li>
          <li>Regenerating your own hexagon: 25 points.</li>
          <li>Video animation: 10 Sparks; all 6 neighbors are required.</li>
          <li>Image regeneration and video animation are free for admins.</li>
        </ul>
        <div className="font-bold text-lg">
          Points for Generation
        </div>
        <div className="mb-4 [&>div]:mb-3">
          <div className="mb-2">
            <div className="font-bold">Starting Balance:</div>
            <div className="ml-4">
              You receive 600 points once, when you first register.
            </div>
          </div>

          <div>
            This is the only points bonus. Upvotes, time spent in the game,
            promo codes, and deleting hexagons do not grant points.
            Refunds can return points already spent on failed operations.
          </div>
          <div>
            You can still upvote other players' hexagons, without points
            rewards for either player. You cannot upvote your own hexagons.
          </div>
        </div>
        <p>
          Development of this project has ended. Sparks purchases and email
          sending are disabled. Generation time and availability depend on
          external AI services.
        </p>

        <p className="mt-4">
          ©️ This project was created by <b>Mikhail Dunaev</b>, and all
          intellectual property rights are owned by <b>Taevavõrk OÜ.</b>
        </p>
        <p className="mt-4">
          Visit the creator's{" "}
          <a
            href="https://www.linkedin.com/in/mikhail-dunaev/"
            rel="noreferrer"
            target="_blank"
          >
            LinkedIn
          </a>{" "}
          profile.
        </p>
        <p className="mt-4">Made in Estonia 🇪🇪 with 💙</p>
      </div>
    </BasicPopup>
  );
};
